import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { BsChevronRight } from 'react-icons/bs';
import { Checkbox, FilterDropdown, FilterDropdownBasicItem, FilterStandardActions, } from '..';
import { classNames, shortenString } from '../../utils';
import SelectAll from '../SelectAll';
import styles from './GenericFilter.module.css';
import { uniq } from 'ramda';
const GenericFilter = ({ className, dropdownClassName, title, useTitleAsIs, titleAlreadyPlural = false, setFilter, selectedItems, items, active, disabled, alignItemsRight, transformItemName, customFilter, filterList, focusedFilterIndex, onFilterSelect, allowLongLabel = false, }) => {
    const [tempSelectedItems, setTempSelectedItems] = useState(selectedItems || []);
    useEffect(() => {
        setTempSelectedItems(uniq(selectedItems) || []);
    }, [selectedItems]);
    const genericFilterClick = (item) => {
        if (tempSelectedItems.includes(item)) {
            return setTempSelectedItems(tempSelectedItems.filter((itemId) => itemId !== item));
        }
        return setTempSelectedItems([...tempSelectedItems, item]);
    };
    const areAllItemsSelected = items && tempSelectedItems.length === items.length;
    const areAnySelected = tempSelectedItems.length !== 0;
    const toggleSelectAll = () => {
        if (areAnySelected) {
            setTempSelectedItems([]);
        }
        else {
            setTempSelectedItems(items || []);
        }
    };
    const selectFilter = (index) => {
        setTempSelectedItems((filterList === null || filterList === void 0 ? void 0 : filterList[index].selectedItems) || []);
        onFilterSelect && onFilterSelect(index);
    };
    const removeFilter = (item) => {
        genericFilterClick(item);
        setFilter &&
            setFilter(tempSelectedItems.filter((itemInList) => itemInList !== item));
    };
    const hasFilterList = filterList === null || filterList === void 0 ? void 0 : filterList.length;
    const hasSelectedItems = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length;
    return (_jsxs(FilterDropdown, Object.assign({ className: className, dropdownClassName: classNames(styles.dropdownList, dropdownClassName), disabled: disabled, title: title, filterLabels: useTitleAsIs || hasFilterList
            ? undefined
            : {
                selectedItems,
                title,
                transformItemName,
                removeFilter,
            }, active: active, alignItemsRight: alignItemsRight, fnToExecuteOnClickOutside: () => {
            setTempSelectedItems(selectedItems || []);
        } }, { children: [hasFilterList && (_jsx("div", Object.assign({ className: styles.filterList }, { children: filterList === null || filterList === void 0 ? void 0 : filterList.map((filter, index) => (_jsxs(FilterDropdownBasicItem, Object.assign({ className: classNames(styles.filterListItem, index === focusedFilterIndex
                        ? styles.selectedFilterListItem
                        : null), onClick: () => selectFilter(index) }, { children: [filter.title, _jsx(BsChevronRight, { size: 14 }, void 0)] }), void 0))) }), void 0)), customFilter && customFilter(), !customFilter && (_jsxs("div", Object.assign({ className: styles.dropdownContainer }, { children: [_jsxs("div", { children: [_jsx(SelectAll, { className: hasFilterList ? styles.selectAllWithFilterList : styles.selectAll, areAnySelected: areAnySelected, toggleSelectAll: toggleSelectAll }, void 0), _jsx("div", Object.assign({ className: styles.itemsContainer }, { children: items === null || items === void 0 ? void 0 : items.map((item) => {
                                    const itemLabel = transformItemName === undefined
                                        ? item.toString()
                                        : transformItemName(item);
                                    return (_jsx(FilterDropdownBasicItem, Object.assign({ className: hasFilterList ? styles.dropdownItemWithFilterList : '' }, { children: _jsx(Checkbox, { className: styles.checkbox, onChange: () => genericFilterClick(item), checked: tempSelectedItems.includes(item), label: allowLongLabel ? itemLabel : shortenString(itemLabel, 25) }, typeof item === 'object'
                                            ? JSON.stringify(item).replace(' ', '_') + 'checkbox'
                                            : item.toString() + 'checkbox') }), typeof item === 'object'
                                        ? JSON.stringify(item)
                                        : item.toString()));
                                }) }), void 0)] }, void 0), _jsx(FilterDropdownBasicItem, Object.assign({ className: classNames(styles.actionContainer, hasFilterList ? styles.dropdownItemWithFilterList : ''), closeOnClick: true }, { children: _jsx(FilterStandardActions, { applyAction: () => {
                                setFilter && setFilter(tempSelectedItems);
                            }, cancelAction: () => {
                                setTempSelectedItems(selectedItems || []);
                            } }, void 0) }), void 0)] }), void 0))] }), void 0));
};
export default GenericFilter;
